import React from 'react';
import { PaymentMethod } from '../../services/types/apitypes';
import PaymentItem from '../payments/PaymentItem';
import {AdditionalPaymentMethod} from "../payments/PaymentsList";

type CardValuePaymentProps = {
  payment: PaymentMethod | AdditionalPaymentMethod;
  click: () => void;
};

export default function CardValuePayment({
  payment,
  click,
}: CardValuePaymentProps) {
  if (typeof payment !== "string") return <PaymentItem payment={payment} click={click} />;
  return <PaymentItem click={click} otherPaymentType={payment} />;
}
